export const RESET_GROUPS = "RESET_GROUPS";
export const GET_GROUPS = "GET_GROUPS";
export const SET_GROUPS = "SET_GROUPS";

export const API_ERROR = "GROUPS_API_ERROR";

export const GET_GROUP = "GET_GROUP";
export const SET_GROUP = "PATCH_GROUP";